import React from 'react';

export type MainData = {
  clusterType?: {
    consumer: boolean;
    business: boolean;
    cpc: boolean;
    enterprise: boolean;
  };
  isInitialized: boolean;
  isValidatingToken: boolean;
  serverType?: {
    master: boolean;
    storage: boolean;
  };
};

export const DEFAULT_MAIN_DATA: MainData = {
  isInitialized: false,
  isValidatingToken: false,
};

type MainDataContextValue = {
  mainData: MainData;
  setMainData: React.Dispatch<React.SetStateAction<MainData>>;
};

export const MainDataContext = React.createContext<MainDataContextValue>({
  mainData: DEFAULT_MAIN_DATA,
  setMainData: () => null,
});
